import React, { memo } from "react";

export const Alart = memo((props) => {
  const {type, text} = props;
  return (
    <div className={`alert mb-4 h5 alert-${type}`} role="alert">
      <i className="fas fa-exclamation-triangle"></i> {text}
    </div>
  );
});